import { FieldGroupDto, FieldItemDto, FieldValidationDto } from "@api/client";
import * as Yup from "yup";

export namespace DynamicValidators {
	export const getSchema = (fields: DynamicValidatorsFields) => {
		let validators: { [key: string]: any } = {};

		Object.keys(fields).forEach((key) => {
			let field = fields?.[key];

			if (field) {
				if ("items" in field) {
					validators[key] = getObjectSchema(field, key);
				} else if ("name" in field) {
					validators[key] = getItemSchema(field);
				}
			}
		});

		let schema = Yup.object().shape(validators);

		// console.log("schema", { schema, fields });

		return schema;
	};

	const getObjectSchema = (field: DynamicValidatorsFieldItem, key: string) => {
		let _validators: { [key: string]: any } = {};

		if (field?.fieldType == "RADIOLIST") {
			if (field?.validation?.when && field?.validation?.required)
				_validators = Yup.string().when(field?.validation?.when.name, {
					is: field?.validation?.when.value,
					then: (schema: any) => schema.required(),
					otherwise: (schema: any) => schema.notRequired(),
				});
			else if (!field?.fieldValidationDto?.when && field?.validation?.required)
				_validators = Yup.string().required();
			else _validators = Yup.string();

			return _validators;
		} else if (field?.fieldType == "CHECKLIST") {
			if (field?.validation?.when && field?.validation?.required)
				return Yup.object()
					.shape(_validators)
					.when(field?.validation?.when.name, {
						is: field?.validation?.when.value,
						then: (schema: any) =>
							schema.test(
								"requiredOne",
								"Seleziona almeno un elemento con un numero diverso da 0",
								(obj: any) => {
									return (
										Object.values(obj).some((value) => {
											if (typeof value == "string") return value === "true";
											if (typeof value == "boolean") return value;
										}) && inputValidationOnCheckbox(obj)
									);
								}
							),
					});
			else if (!field?.validation?.when && field?.validation?.required)
				return Yup.object()
					.shape(_validators)
					.test("requiredOne", "Seleziona almeno un elemento", (obj) => {
						return Object.values(obj).some((value) => {
							if (typeof value == "string") return value === "true";
							if (typeof value == "boolean") return value;
						});
					});
			else {
				field?.items?.forEach((field) => {
					_validators[field?.name!] = getItemSchema(field);
				});
			}
		}

		return Yup.object().shape(_validators);
	};

	const getItemSchema = (field: DynamicValidatorsFieldItem) => {
		// console.log("getItemSchema", field);

		if (!field.visible) return;

		let validator;

		validator = Yup.string();

		if (field?.fieldValidationDto?.when) {
			validator.when(field?.fieldValidationDto?.when.name, {
				is: field?.fieldValidationDto?.when.value,
				then: (schema) => schema.required(),
				otherwise: (schema) => schema.notRequired(),
			});
		} else if (field?.fieldValidationDto?.required) {
			validator = validator.required();
		}

		return validator;
	};

	const inputValidationOnCheckbox = (obj: any) => {
		const checkProperty = (prefix: string) => {
			const booleanKey = `${prefix}_CHECKBOX`;
			const numberKey = `${prefix}_INPUT_NUMBER`;

			const isCheckboxChecked = obj[booleanKey];
			const inputValue = obj[numberKey];

			if (isCheckboxChecked) {
				return inputValue !== "0" && inputValue !== undefined;
			}
			return true;
		};

		const bancoResult = checkProperty("SMART_POS_BANCO");
		const wifiResult = checkProperty("SMART_POS_WIFI");

		return bancoResult && wifiResult;
	};
}

export interface DynamicValidatorsFields {
	[key: string]: DynamicValidatorsFieldItem | undefined;
}

interface DynamicValidatorsFieldItem extends FieldGroupDto, FieldItemDto {
	fieldValidationDto?: DynamicValidatorsFieldItemValidation | undefined;
	validation?: DynamicValidatorsFieldItemValidation | undefined;
}

interface DynamicValidatorsFieldItemValidation extends FieldValidationDto {
	when?: {
		name: string;
		value: string | boolean;
	};
}
